import type { UseMutationResult } from "@tanstack/react-query"
import { useMutation, useQueryClient } from "@tanstack/react-query"

import { queryKeys } from "~/api/cache"

import { publishBatteryArbitrage } from "./battery-arbitrage-cache"
import type {
  BatteryArbitrageDto,
  UpdateBatterySavingsInputDto,
} from "../dto/battery-arbitrage.dto"
import { batteryProposalService } from "../services/battery-proposal.service"

export default function useUpdateBatteryProposalSavingsInput(): UseMutationResult<
  BatteryArbitrageDto,
  unknown,
  { proposalId: string; body: UpdateBatterySavingsInputDto }
> {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ proposalId, body }) =>
      batteryProposalService.updateArbitrageSavingsInput(proposalId, body),
    onSuccess: (arbitrage, { proposalId }) =>
      publishBatteryArbitrage(queryClient, proposalId, arbitrage),
    onError: (_error, { proposalId }) => {
      void queryClient.invalidateQueries({
        queryKey: queryKeys.batteryProposal.arbitrage(proposalId),
      })
    },
  })
}
